import { Card, CardBody } from "reactstrap";
import loader from "../../../assets/loader/loader.gif";

type ProductCardProps = {
  orderListByIdData?: { [key: string]: string | any }; // ✅ Dynamic Key-Value Pair
  isOrderListByIdDataLoading?: boolean;
};

const ProductCard: React.FC<ProductCardProps> = ({
  orderListByIdData,
  isOrderListByIdDataLoading,
}) => {
  console.log(
    "🚀 ~ ProductCard.tsx:11 ~ orderListByIdData:",
    orderListByIdData?.data
  );

  const orderPriceData = orderListByIdData?.data?.orderData;
  //   const data = orderListByIdData?.data?.orderLines;

  return (
    <Card className="text-center p-1 border rounded-3 shadow-sm">
      <CardBody>
        {isOrderListByIdDataLoading ? (
          <div
            style={{
              padding: "20px",
              textAlign: "center",
              width: "90%",
            }}
          >
            <img src={loader} alt="Loading..." style={{ height: 40 }} />
          </div>
        ) : (
          <div>
            <div>
              <strong>{`Order Number : ${orderPriceData?.OrderNumber}`}</strong>
            </div>
            <hr className="my-1" />
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "280px",
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  flexWrap: "wrap",
                  width: "150px",
                  marginRight: "5px",
                }}
              >
                <strong>
                  {orderListByIdData?.data?.orderLines?.length > 1
                    ? "Products"
                    : "Product"}
                </strong>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "150px",
                }}
              >
                <strong>QTY</strong>
                <strong>Total</strong>
              </div>
            </div>
            <hr className="my-1" />

            {orderListByIdData?.data?.orderLines.map(
              (item: any, index: any) => (
                <div key={index} style={{ marginBottom: "12px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                      width: "280px",
                    }}
                  >
                    <div
                      style={{
                        flexShrink: 0,
                        flexWrap: "wrap",
                        width: "150px",
                        marginRight: "5px",
                      }}
                    >
                      {item?.ProductName || "-"}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "110px",
                      }}
                    >
                      <div style={{ flexShrink: 0 }}>{item?.Qty || "-"}</div>
                      <div style={{ flexShrink: 0 }}>
                        {item?.MrpTotal || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
            <hr className="my-1" />
            <p
              className="mb-3"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <strong
                style={{
                  display: "flex",
                  wordBreak: "break-word",
                }}
              >
                Sub Total Without Discount
              </strong>
              <p style={{ textDecorationLine: "line-through", color: "red" }}>
                {orderPriceData?.OrderSubtotal || "-"}
              </p>
            </p>
            <hr className="my-1" />
            <p
              className="mb-3"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <strong>Discount</strong>
              <p>{orderPriceData?.OrderDiscount || "-"}</p>
            </p>
            <hr className="my-1" />
            <p
              className="mb-3"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <strong>Total After Discount</strong>
              <p style={{ color: "#2ECC83", fontWeight: "700" }}>
                {orderPriceData?.OrderTotal || "-"}
              </p>
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ProductCard;
